// extracted by mini-css-extract-plugin
module.exports = {"benefitGroup":"CompanyBenefit_benefitGroup__RTG3k","container":"CompanyBenefit_container__Y5SNb"};